const datasetBrowser = {
  loading: "Hleð gagnasöfnum...",
  failedToLoad: "Ekki tókst að hlaða gagnasöfnum",
  downloadFailed: "Niðurhal mistókst",
  organizationWide: "Fyrir alla stofnunina",
  title: "Skoða gagnasöfn",
  subtitle:
    "Öll gagnasöfn sem þú sérð þvert á verkefnin þín, hvort sem þú hefur aðgang að þeim ennþá eða ekki",
  searchPlaceholder: "Leita eftir nafni, lýsingu eða þeim sem hlóð upp...",
  filters: {
    all: "Allt ({{count}})",
    available: "Tiltækt til niðurhals ({{count}})",
    request: "Þarfnast fyrirspurnar ({{count}})",
  },
  sort: {
    date: "Nýlega bætt við",
    name: "Nafn (A-Ö)",
  },
  noDatasets: "Engin gagnasöfn tiltæk fyrir verkefnin þín",
  noDatasetsMatchSearch: "Engin gagnasöfn samsvara leitinni",
  rowsCount: "{{formatted}} raðir",
  rowsCountUnknown: "Óþekktur fjöldi raða",
  columnsCount: "{{count}} dálkar",
  detailEmpty: {
    search: "Engin gagnasöfn samsvara leitinni.",
    available: "Engin gagnasöfn eru tiltæk til beins niðurhals.",
    request:
      "Engin gagnasöfn þarfnast fyrirspurnar — þú hefur nú þegar aðgang að öllu sem þú sérð.",
    none: "Engin gagnasöfn til að sýna.",
  },
  downloading: "Sæki…",
  downloadWorkbook: "Sækja vinnubók",
  downloadCsv: "Sækja sem CSV",
  downloadCsvTitle: "Fyrsta blað flatt út, styður val á dálkum",
  requestAccess: "Óska eftir aðgangi",
};

export default datasetBrowser;
